import React, { Fragment, useEffect } from 'react';
import { connectHits } from 'react-instantsearch-dom';
import Hit from './Hit';
import FeaturedHit from './FeaturedHit';
import withActiveCarouselState from '../HOC/withActiveCarouselState';
/**
 * Custom Hits component to add custom logic
 * like feature exclusive locations.
 */

const Hits = (props) => {

    let featureLocation = null;

    for (let i = 0; i < props.hits.length; i++) {
        const hit = props.hits[i];
        if (hit.is_featured) {
            featureLocation = hit.id;
            break;
        }
        if (hit.is_exclusive) {
            featureLocation = hit.id;
            break;
        }
    }

    function getMatchedImageTag(hit, searchQuery) {
        // First try original logic for full matches
        if (!!hit._highlightResult && !!hit._highlightResult.mediaTags) {
            let matchedTags = [];

            // Collect all tags that have any match level (full match)
            hit._highlightResult.mediaTags.forEach((tag, key) => {
                if (tag.matchLevel === 'full' && hit.mediaTags && hit.mediaTags[key]) {
                    matchedTags.unshift(hit.mediaTags[key].toLowerCase());
                }
            });

            if (matchedTags.length) {
                matchedTags = [...new Set(matchedTags)]
                return matchedTags;
            }
        }

        // NEW: If no full matches but we have a search query, check for partial word matches
        // For multi-word searches, we send ALL search words to the backend
        // The backend will determine which tags actually exist
        if (searchQuery && typeof searchQuery === 'string' && searchQuery.trim()) {
            const searchWords = searchQuery.toLowerCase().trim().split(/\s+/);

            // Only proceed if this is a multi-word search
            if (searchWords.length > 1 && hit.mediaTags && Array.isArray(hit.mediaTags)) {
                const locationTags = hit.mediaTags.map(tag => tag.toLowerCase());

                // Check if ANY search word matches ANY location tag
                const hasPartialMatch = searchWords.some(word =>
                    locationTags.includes(word)
                );

                if (hasPartialMatch) {
                    // Return ALL search words - backend will filter
                    return searchWords;
                }
            }
        }

        return null;
    }

    return (
        <div className="my-3 overflow-hidden">
            <ul className="row list-unstyled mx-n2">
                {props.hits.map((hit, key) => {
                    // Calculate matched tags once per hit to avoid performance issues
                    const matchedTags = getMatchedImageTag(hit, props.searchQuery);

                    return (
                        <Fragment key={hit.objectID}>
                            {!!hit.isFeatured && (
                                <FeaturedHit
                                    mediaTags={matchedTags}
                                    isActive={props.activeLocations.includes(hit.id)}
                                    onActiveCallback={props.onActiveCallback}
                                    hit={hit}
                                    showMap={props.showMap}
                                    className="first-locations" />
                            )}
                            {featureLocation === hit.id && window.innerWidth >= 768 && (
                                <FeaturedHit
                                    mediaTags={matchedTags}
                                    isActive={props.activeLocations.includes(hit.id)}
                                    onActiveCallback={props.onActiveCallback}
                                    hit={hit}
                                    showMap={props.showMap}
                                    className="first-locations" />
                            )}

                            {!!!hit.isFeatured && window.innerWidth < 768 && featureLocation === hit.id && (
                                <Hit
                                    mediaTags={matchedTags}
                                    feature={true}
                                    isActive={props.activeLocations.includes(hit.id)}
                                    onActiveCallback={props.onActiveCallback}
                                    hit={hit} />
                            )}

                            {featureLocation !== hit.id && (
                                <Hit
                                    isActive={props.activeLocations.includes(hit.id)}
                                    onActiveCallback={props.onActiveCallback}
                                    mediaTags={matchedTags}
                                    hit={hit}
                                    showMap={props.showMap}
                                />
                            )}
                        </Fragment>
                    );
                })}
            </ul>

            {!props.hits.length && (
                <div className="px-0 px-md-2 py-3">No Results Found.</div>
            )}
        </div>
    )

}

const CustomHits = connectHits(withActiveCarouselState(Hits));
export default CustomHits;
